import React from 'react';
import PropTypes from 'prop-types';
import { toLower } from 'lodash';
import { HorseLink } from '../../../shared/links/ProfileLink';

const HorseSireCell = ({
    avgFlatWinDistOfProgeny,
    countryOriginCode,
    horseName,
    horseSexCode,
    horseUid,
    horseYob,
    sireStyleName,
    sireCountryOriginCode,
    sireUid,
    stakesWinnerOrPlaced,
}) => (
    <div>
        <HorseLink
            className={stakesWinnerOrPlaced && 'hp-relatives__stakesPlaced'}
            horseStyleName={horseName}
            horseUid={horseUid}
        />
        <span className="hp-relatives__horseInfo">
            {countryOriginCode && ` (${countryOriginCode}) `}
            {horseYob}{toLower(horseSexCode)}
        </span>
        <br />
        <HorseLink
            className="ui-link_marked"
            horseStyleName={sireStyleName}
            horseUid={sireUid}
        />
        {sireCountryOriginCode && ` (${sireCountryOriginCode})`}
        {avgFlatWinDistOfProgeny && ` ${avgFlatWinDistOfProgeny}f`}
    </div>
);

HorseSireCell.propTypes = {
    avgFlatWinDistOfProgeny: PropTypes.number,
    countryOriginCode: PropTypes.string,
    horseName: PropTypes.string,
    horseSexCode: PropTypes.string,
    horseUid: PropTypes.number,
    horseYob: PropTypes.number,
    sireStyleName: PropTypes.string,
    sireCountryOriginCode: PropTypes.string,
    sireUid: PropTypes.number,
    stakesWinnerOrPlaced: PropTypes.bool,
};

export default HorseSireCell;



// WEBPACK FOOTER //
// ./src/js/horse/pedigree/relativesTable/HorseSireCell.jsx